module.exports = __webpack_public_path__ + "static/media/Result-Cancelled.57204705.svg";